export const buttonColors = {
    primary: "bg-gradient-to-r from-sky-700 to-sky-800 to-sky-600 hover:from-sky-700 hover:to-sky-900",
    secondary: "bg-gradient-to-r from-gray-700 to-gray-900 to-gray-700 hover:from-gray-800 hover:to-black",
    success: "bg-gradient-to-r from-green-600 to-green-800 to-green-600 hover:from-green-700 hover:to-green-900",
    warning: "bg-gradient-to-r from-yellow-600 to-yellow-800 hover:from-yellow-700 hover:to-yellow-900",
    danger: "bg-gradient-to-r from-red-600 to-red-800 hover:from-red-700 hover:to-red-900",
};
export const colors = {
    primary: "bg-gradient-to-r from-sky-700 to-sky-800 to-sky-600",
    secondary: "bg-gradient-to-r from-gray-700 to-gray-900 to-gray-700",
    success: "bg-gradient-to-r from-green-600 to-green-800 to-green-600",
    warning: "bg-gradient-to-r from-yellow-600 to-yellow-800",
    danger: "bg-gradient-to-r from-red-600 to-red-800",
    light: "bg-gradient-to-r from-white to-gray-100",
    lightDarker: "bg-gradient-to-r from-gray-200 to-gray-300"
};
export const plainColors = {
    primary: "bg-sky-400",
    lightBlue: "bg-sky-300",
    secondary: "bg-gray-800",
    success: "bg-green-500",
    warning: "bg-yellow-400",
    danger: "bg-red-400",
    light: "bg-gray-100",
    lightDarker: "bg-gray-300"
};
export const fontsSize = {
    s: "text-[1.5vh]",
    m: "text-[2vh]",
    l: "text-[3vh]",
    xl: "text-[4vh]",
    xxl: "text-[5vh]",
    big: "text-[6vh]",
    giant: "text-[7vh]"
};
export const activeColors = {
    primary: "bg-gradient-to-r from-sky-500 to-sky-600 to-sky-400",  // Darker sky shades
    secondary: "bg-gradient-to-r from-gray-400 to-gray-400 to-gray-300",  // Darker gray
    success: "bg-gradient-to-r from-green-400 to-green-600 to-green-400",  // Darker green
    warning: "bg-gradient-to-r from-yellow-300 to-yellow-400 to-yellow-300",  // Darker yellow
    danger: "bg-gradient-to-r from-red-400 to-red-600",  // Darker red
    light: "bg-gradient-to-r from-gray-200 to-gray-300",  // Darker light gray
    lightDarker: "bg-gradient-to-r from-gray-400 to-gray-500"
};
export const borderRadius = {
    small: "rounded-sm",     // Slightly rounded
    medium: "rounded-md",    // Moderate rounding
    large: "rounded-lg",     // Soft rounded corners
    xl: "rounded-xl",        // More pronounced rounding
    full: "rounded-full",    // Fully rounded (pill shape)
};
export const shadows = {
    sm: "shadow-sm",        // Light shadow
    base: "shadow-md",      // Normal shadow
    lg: "shadow-lg",        // Stronger shadow
    xl: "shadow-[0px_0px_5px_4px_rgba(194,194,194,0.2)]",        // Heavy shadow
    "2xl": "shadow-2xl",    // Maximum shadow
};